import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App.tsx";
import { Providers } from "./app/Providers.tsx";
import { ErrorBoundary } from "./app/ErrorBoundary.tsx";
import "./theme.css";
import "./tailwind.css";
import { initTheme } from "./state/theme.tsx";

/**
 * SPA entry (referenced by index.html as an external module script, so it loads under the BFF's
 * strict content security policy). It mounts the shell inside the app-wide providers and a
 * last-resort error boundary. The theme stylesheet is imported here so Vite emits it as an external
 * `<link>` (no inline style, matching the CSP).
 *
 * `tailwind.css` is the Tailwind CSS 4 + AgentDNA navy/blue theme layer for the new auth/admin
 * screens (controlplane-auth task 11.1). It is imported here so Vite compiles it into the external
 * bundle stylesheet; it is deliberately scoped (no global Preflight, tokens namespaced / under
 * `.oa-auth`) so the existing dark `theme.css` and screens are unaffected. Order matters only in
 * that `theme.css` owns the global defaults and `tailwind.css` adds the opt-in `.oa-auth` layer.
 */
const container = document.getElementById("root");
if (container === null) {
  throw new Error("Root element #root is missing from index.html");
}

// Apply the saved/OS theme to <html> before React mounts, so there is no theme flash on load.
initTheme();

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <Providers>
        <App />
      </Providers>
    </ErrorBoundary>
  </StrictMode>,
);
